import BaseClient from './base-client';
import ModelFactory from './model-factory';

export default class BackendClient extends BaseClient {
  constructor(modelFactoryInstance, options) {
    super(modelFactoryInstance.ns, {
      format: modelFactoryInstance.format,
      ...options,
    });

    if (!(modelFactoryInstance instanceof ModelFactory)) {
      throw new Error(`only BaseModel instances are supported for BackendClient (got ${modelFactoryInstance}).`);
    }

    this.modelFactoryInstance = modelFactoryInstance;
  }

  async req(data, opts = {}) {
    const headers = {};
    const body = {
      BackEnd: opts.resourceName || 1,
      WC: data,
      ...(opts.params || {}),
    };

    if (typeof opts.fields === 'object' && opts.fields instanceof Array) {
      headers['x-obj-attrs'] = opts.fields.join(',');
    }

    if (typeof opts.start === 'number' && typeof opts.size === 'number') {
      body.start = opts.start;
      body.size = opts.size;

      if (body.start < 0) {
        body.start = 0;
      }

      if (body.size <= 25) {
        body.size = 25;
      }
    }

    if (typeof opts.sort === 'string') {
      body.SORT = opts.sort;
    }

    try {
      const response = await this.request('get', opts.id)(body, {
        headers,
      });
      const { status } = response;

      if (status !== 200) {
        return this.handleError({ response });
      }

      return this.format(response);
    } catch (ex) {
      console.error('exception occurred', ex);
      return this.handleError(ex);
    }
  }
}
